<agr-dialog [data]="data" (cancel)="cancel()" (confirm)="confirmSiloDistribution()">
  <app-product-silo
    [quantity]="data.quantity"
    [orderingInformation]="orderingInformation"
    (silosChange)="handleSilosChange($event)"
    (silosAreValid)="handleSilosAreValidChange($event)"
    [selectedSilos]="selectedSilos"
  >
  </app-product-silo>
</agr-dialog>
